import React from "react";
const GreyNoiseAdapterSummary = () => /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "API Token"), /* @__PURE__ */ React.createElement("dd", null, "******"));
export default GreyNoiseAdapterSummary;
